export default "__VITE_ASSET__e9016947__"